<div [ngClass]='[leftAction && rightAction ? "d-flex" : ""]'
     [style.margin]="navActionMargin"
     class='nav-action'>

  <div *ngIf='leftAction' class='nav-action--left'>
    <ng-container *ngFor='let item of leftAction'>
      <pt-navbar-item
        (clickAction)='clickAction.emit($event)' *ngxPermissionsOnly='item.permissVisible'
        [item]='item'
        class='me-2'>
      </pt-navbar-item>
    </ng-container>
  </div>

  <div *ngIf='rightAction' class='nav-action--right'>

    <ng-container *ngIf='obsoleteAction'>
      <pt-navbar-item
        (clickAction)='clickAction.emit($event)'
        *ngxPermissionsOnly='obsoleteAction.permissVisible'
        [item]='obsoleteAction'
        class='ms-2'>
      </pt-navbar-item>
    </ng-container>

    <ng-container *ngIf='!hideDeleteButton'>
      <pt-delete-selected-rows
        (reloadTable)='reloadTable()'
        [entity]='entity'
        [selectedRows]='selectedRows'>
      </pt-delete-selected-rows>
    </ng-container>
    <ng-container *ngIf='showDownloadDocumentsButton'>
      <pt-download-selected-rows
        (clickAction)='clickAction.emit($event)'
        [entity]='entity'
        [selectedRows]='selectedRows'>
      </pt-download-selected-rows>
    </ng-container>
    <ng-container *ngFor='let item of rAction'>
      <pt-navbar-item
        (clickAction)='clickAction.emit($event)'
        *ngxPermissionsOnly='item.permissVisible'
        [item]='item'
        class='ms-2'>
      </pt-navbar-item>
    </ng-container>
  </div>

</div>
